import { render, staticRenderFns } from "./items-history.vue?vue&type=template&id=38c9cd06&scoped=true&"
import script from "./items-history.vue?vue&type=script&lang=js&"
export * from "./items-history.vue?vue&type=script&lang=js&"
import style0 from "./items-history.vue?vue&type=style&index=0&id=38c9cd06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c9cd06",
  null
  
)

export default component.exports